import _ from "lodash";
import config from "config";

/**
 * @param {string} url
 * @returns {boolean}
 *
 * This function is used to check if the URL is allowed to be accessed with credentials.
 */
export const allowURLWithCredentials = url => {
  try {
    const withCredentials = !!config.withCredentials;

    const urlObject = new URL(url);
    const origin = urlObject.origin;

    const isAllowed = _.some([".toddleapp.com", ".toddleapp.cn"], pattern =>
      _.endsWith(origin, pattern)
    );

    return isAllowed && !!withCredentials;
  } catch (error) {
    return false;
  }
};
